import * as PIXI from "pixi.js";

import { Signal } from "signals";
import TutorialPopup from "./popup/TutorialPopup";
import ServiceLocator from "../ServiceLocator";
import Button from "../lib/Button";
import { track_id } from "../service/AudioManager";


export default class Settings extends PIXI.Container
{
    // #region Attributes //

    // private:

    private _base: PIXI.Sprite = null;
    private _baseTextureId: string = null;
    private _dropDownContainer: PIXI.Container = null;

    // Signals.
    private _onHome: Signal = null;
    private _onTutorial: Signal = null;

    // #endregion //


    public get onHome(): Signal { return this._onHome; }
    public get onTutorial(): Signal { return this._onTutorial; }


    // #region Methods //

    // public:

    public init( isHome: boolean = true ): void
    {
        this._onHome = new Signal();
        this._onTutorial = new Signal();

        this._base = new PIXI.Sprite( ServiceLocator.resources[ "settings_toggle_base" + ( isHome ? "" : "_short" ) ].texture );
        this._base.anchor.x = 0.5;
        this._base.visible = false;
        this.addChild( this._base );

        let button: Button = new Button( {  on: "button_settings", pressed: "button_settings_pressed" } );
        button.anchor.set( 0.5 );
        button.position.y = 38;
        button.on( "pointertap", this.onSettingsButton_Click, this );
        this.addChild( button );

        this._dropDownContainer = new PIXI.Container();
        this._dropDownContainer.visible = false;
        this.addChild( this._dropDownContainer );

        button = new Button( { 
            on: "button_tutorial", 
            pressed: "button_tutorial_pressed" } );
        button.anchor.set( 0.5 );
        button.y = 246;
        button.on( "pointertap", this.onTutorialButton_Click, this );
        this._dropDownContainer.addChild( button );

        button = new Button( { on: "button_sfx", pressed: "button_sfx_pressed" } );
        button.name = "sfx_on";
        button.anchor.set( 0.5 );
        button.visible = !ServiceLocator.audio.isMuteSfx;
        button.y = 110;
        button.on( "pointertap", this.onToggleSfxButton_Click, this );
        this._dropDownContainer.addChild( button );

        button = new Button( { on: "button_sfx_off", pressed: "button_sfx_off_pressed" } );
        button.name = "sfx_off";
        button.anchor.set( 0.5 );
        button.visible = ServiceLocator.audio.isMuteSfx;
        button.y = 110;
        button.on( "pointertap", this.onToggleSfxButton_Click, this );
        this._dropDownContainer.addChild( button );

        button = new Button( { on: "button_music", pressed: "button_music_pressed" } );
        button.name = "music_on";
        button.anchor.set( 0.5 );
        button.visible = !ServiceLocator.audio.isMuteMusic;
        button.y = 178;
        button.on( "pointertap", this.onToggleMusicButton_Click, this );
        this._dropDownContainer.addChild( button );

        button = new Button( { on: "button_music_off", pressed: "button_music_off_pressed" } );
        button.name = "music_off";
        button.anchor.set( 0.5 );
        button.visible = ServiceLocator.audio.isMuteMusic;
        button.y = 178;
        button.on( "pointertap", this.onToggleMusicButton_Click, this );
        this._dropDownContainer.addChild( button );

        if ( isHome )
        {
            button = new Button( { on: "button_home", pressed: "button_home_pressed" } );
            button.name = "home";
            button.anchor.set( 0.5 );
            button.y = 309;
            button.on( "pointertap", this.onHomeButton_Click, this );
            this._dropDownContainer.addChild( button );
        }

        ServiceLocator.app.stage.on( "pointerdown", this.onStage_PointerDown, this );

        if ( window.GameSnacks )
        {
            ServiceLocator.main.onGlobalMuteUpdated.add( this._onGlobalMute_Updated, this );

            this._onGlobalMute_Updated( window.GameSnacks.audio.isEnabled() );
        }
    }

        private onSettingsButton_Click(): void
        {
            this._dropDownContainer.visible = !this._dropDownContainer.visible;
            this._base.visible = this._dropDownContainer.visible;
        }

        private onTutorialButton_Click(): void
        {
            this.onSettingsButton_Click();
            
            this._onTutorial.dispatch();
        }

        private onToggleSfxButton_Click(): void
        {
            if ( !window.GameSnacks || window.GameSnacks && window.GameSnacks.audio.isEnabled() )
            {
                ServiceLocator.saved.data.isMuteSfx = !ServiceLocator.saved.data.isMuteSfx;
                ServiceLocator.saved.save();
                
                ServiceLocator.audio.mute( ServiceLocator.saved.data.isMuteSfx, track_id.SFX );
            
                this._dropDownContainer.getChildByName( "sfx_on" ).visible = !ServiceLocator.saved.data.isMuteSfx;
                this._dropDownContainer.getChildByName( "sfx_off" ).visible = ServiceLocator.saved.data.isMuteSfx;
            }
        }

        private onToggleMusicButton_Click(): void
        {
            if ( !window.GameSnacks || window.GameSnacks && window.GameSnacks.audio.isEnabled() )
            {
                ServiceLocator.saved.data.isMuteMusic = !ServiceLocator.saved.data.isMuteMusic;
                ServiceLocator.saved.save();
            
                ServiceLocator.audio.mute( ServiceLocator.saved.data.isMuteMusic, track_id.MUSIC );
            
                this._dropDownContainer.getChildByName( "music_on" ).visible = !ServiceLocator.saved.data.isMuteMusic;
                this._dropDownContainer.getChildByName( "music_off" ).visible = ServiceLocator.saved.data.isMuteMusic;
            }
        }

        private onHomeButton_Click(): void
        {
            this.onSettingsButton_Click();

            this._onHome.dispatch();
        }

        private onStage_PointerDown( event: PIXI.InteractionEvent ): void
        {
            if ( this._dropDownContainer.visible
                && !( this.children.includes( event.target )
                    || this._dropDownContainer.children.includes( event.target ) ) )
            {
                this._dropDownContainer.visible = false;
                this._base.visible = false;
            }
        }

        private _onGlobalMute_Updated( isAudioEnabled: boolean ): void
        {
            if ( !isAudioEnabled )
            {
                this._dropDownContainer.getChildByName( "sfx_on" ).visible = false;
                this._dropDownContainer.getChildByName( "sfx_off" ).visible = true;
                //
                this._dropDownContainer.getChildByName( "music_on" ).visible = false;
                this._dropDownContainer.getChildByName( "music_off" ).visible = true;
            }
            else
            {
                this._dropDownContainer.getChildByName( "music_on" ).visible = !ServiceLocator.saved.data.isMuteMusic;
                this._dropDownContainer.getChildByName( "music_off" ).visible = !this._dropDownContainer.getChildByName( "music_on" ).visible;
                //
                this._dropDownContainer.getChildByName( "sfx_on" ).visible = !ServiceLocator.saved.data.isMuteSfx;
                this._dropDownContainer.getChildByName( "sfx_off" ).visible = !this._dropDownContainer.getChildByName( "sfx_on" ).visible;
            }
        }

    public end(): void 
    {
        this._onHome.dispose();
        this._onHome = null;

        this._onTutorial.dispose();
        this._onTutorial = null;

        if ( window.GameSnacks )
        {
            ServiceLocator.main.onGlobalMuteUpdated.remove( this._onGlobalMute_Updated, this );
        }

        ServiceLocator.app.stage.off( "pointerdown", this.onStage_PointerDown, this );
    }

    // #endregion //
}